<template>
<div>
    <vs-card style="min-height:600px">
        <vs-row>
            <vs-col class="w-1/2">
                <h4 style="padding-left:20%">Lab </h4>
            </vs-col>
            <vs-col class="w-1/2">
                <router-link :to="{path:'/patientTray',query:{patientId:patientId}}" style="margin-left:95%;cursor:pointer">
                    <feather-icon icon="XIcon" class="custom-class" title="close"></feather-icon>
                </router-link>
            </vs-col>
        </vs-row>
        <vs-divider>{{request}}</vs-divider>

        <div style="padding-left:10%;padding-right:10%">

            <!-- error message -->
            <vs-row style="margin-bottom:20px">
                <vs-alert color="danger" icon-pack="feather" icon="icon-info" v-for="error in errors.all()" v-bind:key="error">
                    <span>{{error}}</span>
                </vs-alert>
            </vs-row>

            <vs-row>
                <vs-alert color="danger" icon-pack="feather" icon="icon-info" v-for="(errors,err) in errorMessage" v-bind:key="err">
                    <span>{{errors}}</span>
                </vs-alert>
            </vs-row>

            <!-- ------ -->
            <!-- form -->
            <vs-row>
                <vs-col class="w-1/2">
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full topPad">
                            <span class="inputStyles">Document Name</span>
                        </div>
                        <div class="vx-col ">
                            <vs-input v-validate="'required'" name="DocumentName" class="w-full" v-model="labform.documentName" />
                        </div>
                    </div>

                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full" style="padding-top:2%;">
                            <span class="inputStyles">Note</span>
                        </div>
                        <div class="vx-col">
                            <vs-textarea v-model="labform.note" />
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span class="inputStyles">File Upload</span>
                        </div>
                        <div class="vx-col">

                            <input v-validate="'required'" ref="file" name="File" type="file" @change="onhandler">

                        </div>
                    </div>
                </vs-col>
            </vs-row>

            <!-- --- -->
        </div>

        <!-- footer -->
    </vs-card>
    <vs-row>
        <vs-card class="footer">
            <div class="btn-group" style="margin-left:70%">
                <vs-button :to="{path:'/patientTray',query:{patientId:patientId}}" color="danger" type="filled">Exit</vs-button>
                <vs-button :disabled="this.saveFlag" color="success" @click="saveLab" type="filled">Save</vs-button>
            </div>
        </vs-card>

        <!-- ------- -->
    </vs-row>
</div>
</template>

<script>
export default {
    data() {
        return {
            saveFlag: false,
            request: "",
            labform: {
                documentName: "",
                note: ""
            },
            patientId: "",
            errorMessage: "",
            file: ''
        }
    },
    created(){
    this.patientId=this.$route.query.patientId;
    },
    methods: {
        saveLab() {
            this.$validator.validate().then(valid => {
                if (!valid) {
                    this.errors.any();
                } else {

                    var request = {
                        companyId: this.$session.get('companyId'),
                        patientId: this.patientId,
                        documentName: this.labform.documentName,
                        note: this.labform.note,
                        file: this.file,
                    }

                    this.$http.post(
                            "savelabreports",
                            JSON.stringify(request), {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        .then(response => {
                            this.$vs.notify({
                                title: 'Saved Successfully',
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-check',
                                position: 'top-center'
                            });
                            this.saveFlag = true;

                        });
                }
            });
        },

        onhandler(e) {
            var f = e.target.files[0];
            var reader = new FileReader()
            reader.readAsDataURL(f)
            reader.onload = () => {
                this.file = reader.result;
            };
        }
    }
}
</script>

<style scoped>
.footer {
    position: fixed;
    left: 0;
    bottom: -20px;
    width: 100%;
    z-index: 500;

}
.inputStyles{
    font-size: 11.8px;
    font-weight: 600;
}
.topPad{
    padding-top: 7px;
}
</style>
